import { stringToEnum } from '@snap-types/models/common';

export enum OriginalSource {
  DWH_STG_VIS = 'DWH_STG_VIS',
  DWH_STG_MWIFAS = 'DWH_STG_MWIFAS',
  SNAP = 'SNAP',
}

export const originalSourceSchema = stringToEnum(OriginalSource);

export enum RunRateType {
  DAYS_PER_LOAD = 'DAYS_PER_LOAD',
  HRS_PER_PC = 'HRS_PER_PC',
  PCS_PER_MIN = 'PCS_PER_MIN',
  HRS_PER_LOAD = 'HRS_PER_LOAD',
  PCS_PER_HR = 'PCS_PER_HR',
  PCS_PER_DAY = 'PCS_PER_DAY',
  MIN_PER_PC = 'MIN_PER_PC',
  DAYS_PER_PC = 'DAYS_PER_PC',
  LOADS_PER_HR = 'LOADS_PER_HR',
  LOADS_PER_DAY = 'LOADS_PER_DAY',
}

export const runRateTypeSchema = stringToEnum(RunRateType);

export enum ConfigStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const configStatusSchema = stringToEnum(ConfigStatus);

export enum ConfigEntities {
  SITE = 'SITE',
  USER = 'USER',
  CUSTOMER = 'CUSTOMER',
  PART = 'PART',
  QUOTE = 'QUOTE',
  QUOTE_LINE = 'QUOTE_LINE',
  QTY_BRK = 'QTY_BRK',
  REQ_PART = 'REQ_PART',
}

export const configEntitiesSchema = stringToEnum(ConfigEntities);

export enum ScrapYieldType {
  SCRAP = 'SCRAP',
  YIELD = 'YIELD',
}

export const scrapYieldTypeSchema = stringToEnum(ScrapYieldType);

export const scrapYieldTypeLabelMapping = {
  SCRAP: 'Scrap',
  YIELD: 'Yield',
} as const satisfies Record<ScrapYieldType, string>;

export enum QtyPerType {
  START = 'START',
  END = 'END',
}

export const qtyPerTypeSchema = stringToEnum(QtyPerType);

export enum QuoteBuilderVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export const quoteBuilderVersionSchema = stringToEnum(QuoteBuilderVersion);

export enum PriceStrategy {
  FixedCustomer = 'FixedCustomer',
  FixedDefault = 'FixedDefault',
  FixedDiscount = 'FixedDiscount',
  FixedMarket = 'FixedMarket',
  UserImport = 'UserImport',
  TargetGrossMargin = 'TargetGrossMargin',
  TargetContributionMargin = 'TargetContributionMargin',
  PriceSegmentation = 'PriceSegmentation',
  CAPPriceSegmentation = 'CAPPriceSegmentation',
  UserPrice = 'UserPrice',
  NewPartUserPrice = 'NewPartUserPrice',
  NewPartUserCost = 'NewPartUserCost',
  RAFFixedMarket = 'RAFFixedMarket',
  RAFTargetGrossMargin = 'RAFTargetGrossMargin',
  NewPart = 'NewPart',
}

export const priceStrategySchema = stringToEnum(PriceStrategy);

export enum LeadTimeStrategy {
  ConstantValue = 'ConstantValue',
  PlanningLeadtime = 'PlanningLeadtime',
  RAFFixedMarket = 'RAFFixedMarket',
}

export const leadTimeStrategySchema = stringToEnum(LeadTimeStrategy);

export enum UnitsPerPieceType {
  START = 'START',
  END = 'END',
}

export const unitsPerPieceTypeSchema = stringToEnum(UnitsPerPieceType);

export enum CustomerPotentialRanking {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

export const customerPotentialRankingSchema = stringToEnum(
  CustomerPotentialRanking,
);

export enum ProductComplexityRanking {
  Simple = 'Simple',
  Moderate = 'Moderate',
  Complex = 'Complex',
}

export const productComplexityRankingSchema = stringToEnum(
  ProductComplexityRanking,
);

export enum ConfiguratorSnapshotVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export const configuratorSnapshotVersionSchema = stringToEnum(
  ConfiguratorSnapshotVersion,
);
